<template>
  <div class="accountSetting">
    <headers class="herderNav" ref="header" :isChange="false"/>
    <div class="accountSetCon">
      <div class="conLeft">
        <div class="conLeftTab" v-for="(ele,index) in leftTabs" :key="index" @click="switchTab(index,ele)" :class="n == index ? 'actives':''">
          <img :src="n==index?ele.icon3:ele.icon1 ">
          <p>{{ele.name}} <span style="margin-left: 66px;"><i class="el-icon-arrow-right"></i></span></p>
        </div>
      </div>
      <div class="conRightCon">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import headers from '@/components/header.vue'
  export default{
    components:{
      headers,
    },
    data(){
      return{
        n:0,
        leftTabs:[
          {icon1:require('../../assets/accountSeting/tabIcon1.png'),name:'账号安全',icon2:require('../../assets/accountSeting/RightIcon.png'),
          icon3:require('../../assets/accountSeting/tabsetIcon1.png'),type:1},
          {icon1:require('../../assets/accountSeting/tabIcon2.png'),name:'个人信息',icon2:require('../../assets/accountSeting/RightIcon.png'),
          icon3:require('../../assets/accountSeting/tabsetIcon2.png'),type:2},
          {icon1:require('../../assets/accountSeting/tabIcon3.png'),name:'我的练习',icon2:require('../../assets/accountSeting/RightIcon.png'),
          icon3:require('../../assets/accountSeting/tabsetIcon3.png'),type:3}
        ]
      }
    },
    mounted() {
      this.$refs.header.isTop=false;
      this.$refs.header.headerBack.background = '#ffffff';
      this.$refs.header.herderTits.color = '#666666';
      this.$refs.header.headerIcon = require('@/assets/home/headerNav.png');
      this.$refs.header.loginButton = {
         background : '#618aff',
         color:'#fff'
      }
      this.$refs.header.phoneButton = {
      color:'#618aff',
      border: '1px solid #618aff'
       }
    },
    methods:{
      switchTab(i,item){
        this.n = i;
        console.log(i)
        if(i == 0){
          this.$router.push('/number')
        }
        else if(i == 1){
          this.$router.push('/personalInfos')
        }
        else{
          this.$router.push('/onlinePractice')
        }
        // item.icon1 = item.icon3
      }
    },
  }
</script>

<style scoped>
  @import url("../../assets/css/accountSeting.css");
</style>



// WEBPACK FOOTER //
// src/view/accountSetting/accountSettings.vue